import createSvgIcon from '../Utils/CreateSvgIcon';

export const Copy = createSvgIcon(
  <path
    d="M7 2H6V3V6H4V8V20V22H6H15H17V20H19H20V19V3V2H19H7ZM17 18H18V4H8V6L15 6.00001H17L17 8.00001L17 18ZM6 8L15 8.00001V20H6V8Z"
    fillRule="evenodd"
  />,
  'Copy',
);
